import { render, staticRenderFns } from "./MsgBox.vue?vue&type=template&id=aeb9d6f8&scoped=true"
import script from "./MsgBox.vue?vue&type=script&lang=js"
export * from "./MsgBox.vue?vue&type=script&lang=js"
import style0 from "./MsgBox.vue?vue&type=style&index=0&id=aeb9d6f8&prod&lang=scss"
import style1 from "./MsgBox.vue?vue&type=style&index=1&id=aeb9d6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb9d6f8",
  null
  
)

export default component.exports